import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  Row,
  Container,
  CardHeader,
  Col,
  CardBody,
  CardTitle,
  NavItem,
  TabContent,
  NavLink,
  Nav,
  CardText,
  Button,
  Table,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  TabPane,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Dropdown,
  CardFooter,
  UncontrolledTooltip,
} from "reactstrap";
import Select from "react-dropdown-select";
import { Link, useNavigate, useParams } from "react-router-dom";
import tutorsModal from "models/tutors.modal";
import DeviceUUID from "device-uuid";
import { helper } from "lib/helper";
import SubAdminModal from "models/user.modal";
import moment from "moment";
import levelModal from "models/level.modal";
import Finanacemanagement from "../../models/financemanagement.modal";
import Parentmodel from "../../models/parents.modal";
import AttendanceModel from "../../models/Attendance.modal";
import Loader from "components/loader/Loader";

const FinanceManagement = () => {
  const [clientId, setClientId] = useState();
  const [selectedclass, setSelectedclass] = useState("");
  const [cycle, setcycle] = useState(null);
  const [classid, setClassid] = useState();
  const [parentdata, setParentdata] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const parmas = useParams();
  const [item, setitem] = useState();
  const [classlist, setClasslist] = useState();
  const [status, setStatus] = useState("All");
  const [clientdetail, setClientdetail] = useState();
  const [idclass, setidClass] = useState();

  const EditInvoice = async (event) => {
    event.preventDefault();
    const form = new FormData(event.target);
    if (selectedClient) {
      form.append("client_id", selectedClient?.[0]?.idofp);
    } else {
      form.append("client_id", item?.client_id);
    }
    if (idclass) {
      form.append("class_id", idclass);
    } else {
      form.append("class_id", item?.class_id);
    }
    if (classidform) {
      form.append("cycle_id[]", classidform);
    } else {
      form.append("cycle_id[]", item?.cycle_id);
    }
    Finanacemanagement.EditInvoice(clientId, form)
      .then((responce) => {
        helper.sweetalert.toast(responce.data?.message, "success");
        getList();
      })
      .catch((error) => {});
  };
  const MartoPaid = async (event) => {
    event.preventDefault();
    const form = new FormData(event.target);
    form.append("payment_for", "parentInvoice");
    form.append("salary_invoice_id", clientId);
    const originalDate = form.get("date");

    if (originalDate) {
      const [year, month, day] = originalDate.split("-");
      const formattedDate = `${day}-${month}-${year}`;
      form.set("date", formattedDate);
    }
    Finanacemanagement.markedinvoicepaid(form)
      .then((responce) => {
        getList();
        helper.sweetalert.toast(responce.message, "success");
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const invoicelist = async (id) => {
    Finanacemanagement.invoicelistbyid(id)
      .then((responce) => {})
      .catch((error) => {});
  };
  const deleteinvoice = async (id) => {
    Finanacemanagement.deleteInvoice(id)
      .then((responce) => {
        helper.sweetalert.toast(responce?.data?.message, "success");
        getList();
      })
      .catch((error) => {});
  };
  const getcycle = async (id) => {
    AttendanceModel.getcycle(id)
      .then((responce) => {
        setcycle(responce);
      })
      .catch((error) => {});
  };
  useEffect(() => {
    getcycle();
  }, [selectedclass]);

  const getclass = async () => {
    setcycle("");

    AttendanceModel.getclassbyparent(item?.client?.username)
      .then((responce) => {
        setClasslist(responce?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  useEffect(() => {
    getclass();
  }, [item]);

  console.log("dddd", classlist);

  const getparentlist = async () => {
    Parentmodel.Parentlistss()
      .then((responce) => {
        setParentdata(responce);
      })
      .catch((error) => {});
  };

  console.log("raise parent", parentdata);
  const [alldata, setAlldata] = useState();
  const [unpaiddata, setUnpaiddata] = useState();
  const [pendingdata, setPendingdata] = useState();
  const [paiddata, setPaiddata] = useState();
  const [voiddata, setVoiddata] = useState();

  const datacount = () => {
    Finanacemanagement.listofInvoice()
      .then((result) => {
        setAlldata(result?.data?.data);
      })
      .catch((error) => {});
    Finanacemanagement.listofInvoicestatus("Unpaid")
      .then((result) => {
        setUnpaiddata(result?.data?.data);
      })
      .catch((error) => {});
    Finanacemanagement.listofInvoicestatus("Pending")
      .then((result) => {
        setPendingdata(result?.data?.data);
      })
      .catch((error) => {});
    Finanacemanagement.listofInvoicestatus("Completed")
      .then((result) => {
        setPaiddata(result?.data?.data);
      })
      .catch((error) => {});
    Finanacemanagement.listofInvoicestatus("Void")
      .then((result) => {
        setVoiddata(result?.data?.data);
      })
      .catch((error) => {});
  };
  useEffect(() => {
    datacount();
  }, []);
  console.log("data count invoice", alldata);
  const getList = async () => {
    setIsLoading(true);
    if (status == "All") {
      await Finanacemanagement.listofInvoice()
        .then((result) => {
          setIsLoading(false);
          console.log("invoice list", result);
          setDataList(result);
          // if (result) {
          //  setDataList(result?.data);
          //  setCurrentPage(result?.meta?.current_page);
          //  setPerPage(result?.meta?.per_page);
          // }
        })
        .catch((error) => {
          setIsLoading(false);
        });
    } else {
      await Finanacemanagement.listofInvoicestatus(status)
        .then((result) => {
          setIsLoading(false);
          console.log("invoice list", result);
          setDataList(result);
          // if (result) {
          //  setDataList(result?.data);
          //  setCurrentPage(result?.meta?.current_page);
          //  setPerPage(result?.meta?.per_page);
          // }
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
  };
  useEffect(() => {
    getList();
  }, [status]);
  const Invoicesubmmit = async (event) => {
    event.preventDefault();

    const form = new FormData(event.target);
    if (classidform) {
      form.append("cycle_id[]", classidform);
      form.append("client_id", parentid);
    }

    Finanacemanagement.addInvoice(form)
      .then((responce) => {
        console.log("responce raise", responce);
        helper.sweetalert.toast(responce.data?.message, "success");
        getList();
      })
      .catch((error) => {
        helper.sweetalert.toast(error?.response?.data?.message, "warning");
      });
  };

  useEffect(() => {
    getList();
    getparentlist();
  }, []);

  const GetClass = async (id) => {
    setcycle("");

    AttendanceModel.getclassbyparent(id)
      .then((responce) => {
        setClasslist(responce?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  console.log("6766hfhnff", classlist);
  console.log("Total client", parentdata);
  const handleDownload = (url) => {
    const newWindow = window.open(url, "_blank");
    if (newWindow) {
      newWindow.focus();
    } else {
      console.error("Popup blocked. Please enable popups and try again.");
    }
  };
  const [modal, setModal] = useState(false);

  const toggle = () => {
    setModal(!modal);
    setcycle("");
  };

  const [modal1, setModal1] = useState(false);
  const toggle1 = () => setModal1(!modal1);

  const [modal2, setModal2] = useState(false);
  const toggle2 = () => setModal2(!modal2);
  const [modal3, setModal3] = useState(false);
  const toggle3 = () => setModal2(!modal2);

  const [modala, setModala] = useState(false);
  const togglea = () => setModala(!modala);

  const [ListLevel, setListLevel] = useState();
  const [levelId, setLevelId] = useState("");

  const getListBylevelId = async () => {
    // setLevelId(id);
    setIsLoading(true);
    await levelModal
      .listbyLevelid(levelId)
      .then((result) => {
        setIsLoading(false);
        if (result) {
          setListLevel(result?.data?.data);
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
      });
  };

  useEffect(() => {
    if (levelId !== "") {
      getListBylevelId();
    }
  }, [levelId]);

  const [selectuser, setSelectdUser] = useState("");
  const interViewUser = (id) => {
    setSelectdUser(id);
  };
  console.log(selectuser, "selectuser");

  const [addsLoadig, setAddsLoadig] = useState(false);
  const navigate = useNavigate();

  const [meetingDate, setMeetingDate] = useState("");
  const handleDateChange = (event) => {
    const { value } = event.target;
    setMeetingDate(value); // Update meetingDate state with the selected date
  };
  const formattedDate = moment(meetingDate).format("DD/MM/YYYY");
  const [priceStart, setPriceStart] = useState(""); // State to store start time
  const [priceUpto, setPriceUpTO] = useState(""); // State to store end time
  const [name, setName] = useState();

  // Function to handle changes in the start time input
  const handlepriceStart = (event) => {
    const { value } = event.target;
    setPriceStart(value); // Update startTime state with the selected time
  };

  // Function to handle changes in the end time input
  const handlePriceUpto = (event) => {
    const { value } = event.target;
    setPriceUpTO(value); // Update endTime state with the selected time
  };

  const handleName = (event) => {
    const { value } = event.target;
    setName(value); // Update endTime state with the selected time
  };

  const [inputsAbout, setInputsAbout] = useState([{ id: 1, value: "" }]);

  const handleInputChangeAbout = (index, event) => {
    const values = [...inputsAbout];
    values[index].value = event.target.value;
    setInputsAbout(values);
  };
  const inputsProvalues = inputsAbout && inputsAbout?.map((item) => item.value);
  const handleAddInputAbout = () => {
    const newInputs = [
      ...inputsAbout,
      { id: inputsAbout.length + 1, value: "" },
    ];
    setInputsAbout(newInputs);
  };
  const handleRemoveInputAbout = (index) => {
    if (inputsAbout?.length === 1) return; // Don't delete if only one input field is there
    const values = [...inputsAbout];
    values.splice(index, 1);
    setInputsAbout(values);
  };

  const clearState = () => {
    setPriceStart("");
    setPriceUpTO("");
    setName("");
    setInputsAbout("");
  };

  const handleSubmit = (event) => {
    setAddsLoadig(true);
    event.preventDefault();
    const data = {
      name: name,
      price_start: parseInt(priceStart),
      price_upto: parseInt(priceUpto),
      about: inputsProvalues,
    };
    levelModal
      .createLelvel(data)
      .then((response) => {
        clearState();

        helper.sweetalert.toast(response.message, "success");
        toggle();
        setAddsLoadig(false);
      })
      .catch((error) => {
        setAddsLoadig(false);
      });
  };

  const [formData, setFormData] = useState({
    name: "",
    price_start: "",
    price_upto: "",
  });

  useEffect(() => {
    // Set default values when the component mounts
    if (ListLevel) {
      setFormData({
        name: ListLevel?.name || "",
        price_start: ListLevel.price_start || "",
        price_upto: ListLevel.price_upto || "",
      });
    }
  }, [ListLevel]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const [inputseditDesc, setInputseditDess] = useState([]);

  useEffect(() => {
    if (ListLevel && ListLevel.about) {
      setInputseditDess(
        ListLevel.about.map((value, index) => ({
          id: index,
          value: value || "",
        }))
      );
    }
  }, [ListLevel]);

  // Function to handle changes in the edit description input fields
  const handleInputChangeeditDesc = (index, event) => {
    const values = [...inputseditDesc];
    values[index].value = event.target.value;
    setInputseditDess(values);
  };

  // Function to handle adding a new edit description input field
  const handleAddInputeditDesc = () => {
    const newInputs = [
      ...inputseditDesc,
      { id: inputseditDesc.length, value: "" },
    ];
    setInputseditDess(newInputs);
  };

  // Function to handle removing an edit description input field
  const handleRemoveInputeditDesc = (index) => {
    if (inputseditDesc.length === 1) return; // Don't delete if only one input field is there
    const values = [...inputseditDesc];
    values.splice(index, 1);
    setInputseditDess(values);
  };
  const inputsProvalueseditDesc =
    inputseditDesc && inputseditDesc?.map((item) => item.value);

  const handleSubmitEditLevel = (event) => {
    setAddsLoadig(true);
    event.preventDefault();
    const data = {
      id: levelId,
      name: formData.name,
      price_start: parseInt(formData.price_start),
      price_upto: parseInt(formData.price_upto),
      about: inputsProvalueseditDesc,
    };

    levelModal
      .editLevel(data)
      .then((response) => {
        helper.sweetalert.toast(response.message, "success");
        setFormData("");
        toggle1();
        setAddsLoadig(false);
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response.data.message, "error");
        console.log(error, "error");
        setAddsLoadig(false);
        setFormData("");
      });
  };

  const handleDel = async (delId) => {
    helper.sweetalert
      .confirm("Are you sure you want to delete this Message", "info", true)
      .then((result) => {
        if (result.isConfirmed) {
          levelModal.removeLevel(delId).then((res) => {
            helper.sweetalert.toast(res.data?.message);
          });
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
      });
  };
  const [summary, setsummary] = useState();
  const getdata = async () => {
    Finanacemanagement.getsummary()
      .then((responce) => {
        console.log("responce", responce);
        setsummary(responce?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  useEffect(() => {
    getdata();
  }, []);
  const [searchTerm, setSearchTerm] = useState(""); // State for search input

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredData = dataList?.data?.data?.filter((item) => {
    const clientName =
      `${item?.client?.first_name} ${item?.client?.last_name}`.toLowerCase();
    const status = item?.status?.toLowerCase();
    const className = "Class 1".toLowerCase(); // Replace "Class 1" if you have class names dynamically
    const amount = item?.total_amount?.toString(); // Convert amount to string for comparison

    return clientName.includes(searchTerm.toLowerCase());
  });

  const [dropdownstatus, setDropdownstatus] = useState();
  const searchbydate = async (event) => {
    setDataList("");
    setIsLoading(true);
    event.preventDefault();
    const form = new FormData(event.target);
    const from = form.get("from_date");
    const to = form.get("to_date");

    Finanacemanagement.listOfInvoiceDate(from, to, dropdownstatus)
      .then((result) => {
        setIsLoading(false);

        setDataList(result);
        // if (result) {
        //  setDataList(result?.data);
        //  setCurrentPage(result?.meta?.current_page);
        //  setPerPage(result?.meta?.per_page);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };
  const [classidform, setClassidform] = useState();
  const [selectedClient, setSelectedClient] = useState(null);
  const [parentid, setParentid] = useState(null);

  const options = parentdata?.data
    ? [
        // { value: "", label: "Select Client" }, // Add an empty option to reset selection
        ...parentdata.data.map((item) => ({
          value: item?.mobile,
          label: `${item?.parent?.first_name} ${item?.parent?.last_name} (${item?.mobile})`,
          idofp: item?.parent?.id,
        })),
      ]
    : [];

  const handleChange = (selectedOption) => {
    console.log(selectedOption, "new new");
    setSelectedClient(selectedOption);
    GetClass(selectedOption?.[0]?.value);
    setParentid(selectedOption?.[0]?.idofp);
  };

  return (
    <div className="pt-5 px-4">
      <Row className="mt-4">
        <Col md="12">
          <Card style={{ float: "right", display: "flex" }}>
            <CardBody>
              <CardTitle>Total</CardTitle>
              <div>
                <p>
                  Total Invoices:{" "}
                  <span style={{ float: "right" }}>
                    {summary?.total_invoice}
                  </span>
                </p>
                <p>
                  Gross Fee:{" "}
                  <span style={{ float: "right" }}>
                    {
                      summary?.parents_fees /*summary?.net_margin
                      ? `${parseFloat(summary.net_margin)
                          .toFixed(2)
                          .slice(0, 5)}%`
                      : "N/A"*/
                    }
                  </span>
                </p>
                <p>
                  Tutor's Salary:{" "}
                  <span style={{ float: "right" }}>
                    {summary?.tutors_salary}
                  </span>
                </p>
                <p>
                  Net Margin:{" "}
                  <span style={{ float: "right" }}>
                    {summary?.net_margin_amount} |{" "}
                    {(
                      (summary?.net_margin_amount / summary?.parents_fees) *
                      100
                    ).toFixed(2)}
                    %{" "}
                  </span>
                </p>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row>
        <div className="col">
          <Card className="shadow">
            <CardHeader className="border-0  ">
              <h3 className="mb-0">Raise Invoice</h3>
              <form onSubmit={searchbydate}>
                <div className="d-flex flex-row align-items-center mt-2">
                  <span
                    style={{
                      fontWeight: "bold",
                      marginRight: "8px",
                      display: "flex",
                    }}
                  >
                    Filters:-{" "}
                  </span>
                  <div className="d-flex align-items-center">
                    <span
                      style={{
                        fontSize: "15px",
                      }}
                    >
                      From
                    </span>
                    <Input
                      name="from_date"
                      className="mr-4 ml-2"
                      type="date"
                      placeholder="Search by Date"
                      size="sm"
                      required
                    />
                  </div>
                  <div className="d-flex align-items-center">
                    <span
                      style={{
                        fontSize: "15px",
                      }}
                    >
                      To
                    </span>
                    <Input
                      name="to_date"
                      className="mr-4 ml-2"
                      type="date"
                      placeholder="Search by Date"
                      size="sm"
                      required
                    />
                  </div>

                  <Input
                    id="forType"
                    name="status"
                    type="select"
                    size="sm"
                    style={{ width: "200px" }}
                    onChange={(e) => {
                      setDropdownstatus(e.target.value);
                    }}
                  >
                    <option value="">Select Status</option>
                    <option value="All">All</option>
                    <option value="Void">Void</option>
                    <option value="Pending">Pending</option>
                    <option value="Completed">Paid</option>
                  </Input>
                  <div className="position-relative ml-4">
                    <Input
                      className="mr-4 ml-2"
                      type="text"
                      placeholder="Search by Client"
                      size="sm"
                      style={{ width: "200px", paddingLeft: "30px" }}
                      value={searchTerm}
                      onChange={handleSearch} // Update the search term on input change
                    />
                    <i
                      className="fa fa-search position-absolute"
                      style={{
                        top: "50%",
                        left: "15px",
                        transform: "translateY(-50%)",
                        fontSize: "14px",
                        color: "#aaa",
                      }}
                    ></i>
                  </div>
                  <Button
                    size="sm"
                    type="submit"
                    style={{
                      backgroundColor: "orange",
                      color: "white",
                      border: "none",
                      width: "150px",
                      height: "30px",
                    }}
                  >
                    Search
                  </Button>

                  <Button
                    size="sm"
                    onClick={toggle}
                    style={{
                      backgroundColor: "#080278",
                      color: "white",
                      border: "none",
                      width: "150px",
                      height: "30px",
                    }}
                  >
                    +Add
                  </Button>
                </div>
              </form>
            </CardHeader>
            <Row
              className="mb-1"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Col
                md={8}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "nowrap",
                  justifyContent: "space-between",
                }}
              >
                <div
                  className="me-3 pl-5"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    color: status == "All" ? "blue" : "black",
                  }}
                  onClick={() => {
                    setStatus("All");
                  }}
                >
                  <span>All</span>{" "}
                  <span className="badge bg-secondary ms-1 ">
                    (
                    <span
                      style={{
                        color: status == "All" ? "black" : "blue",
                      }}
                    >
                      {" "}
                      {alldata?.length}{" "}
                    </span>
                    )
                  </span>
                </div>
                <div
                  className="me-3"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    color: status == "Unpaid" ? "blue" : "black",
                  }}
                  onClick={() => {
                    setStatus("Unpaid");
                  }}
                >
                  <span>Unpaid</span>{" "}
                  <span className="badge bg-secondary ms-1 ">
                    (
                    <span
                      style={{
                        color: status == "Unpaid" ? "black" : "blue",
                      }}
                    >
                      {" "}
                      {unpaiddata?.length}{" "}
                    </span>
                    )
                  </span>
                </div>
                <div
                  className="me-3"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    color: status == "Pending" ? "blue" : "black",
                  }}
                  onClick={() => {
                    setStatus("Pending");
                  }}
                >
                  <span>Pending</span>{" "}
                  <span className="badge bg-secondary ms-1 ">
                    (
                    <span
                      style={{
                        color: status == "Pending" ? "black" : "blue",
                      }}
                    >
                      {" "}
                      {pendingdata?.length}{" "}
                    </span>
                    )
                  </span>
                </div>
                <div
                  className="me-3"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    color: status == "Completed" ? "blue" : "black",
                  }}
                  onClick={() => {
                    setStatus("Completed");
                  }}
                >
                  <span>Paid</span>{" "}
                  <span className="badge bg-secondary ms-1 ">
                    (
                    <span
                      style={{
                        color: status == "Paid" ? "black" : "blue",
                      }}
                    >
                      {" "}
                      {paiddata?.length}{" "}
                    </span>
                    )
                  </span>
                </div>
                <div
                  className="me-3"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    color: status == "Void" ? "blue" : "black",
                  }}
                  onClick={() => {
                    setStatus("Void");
                  }}
                >
                  <span>Void</span>{" "}
                  <span className="badge bg-secondary ms-1 ">
                    (
                    <span
                      style={{
                        color: status == "Void" ? "black" : "blue",
                      }}
                    >
                      {" "}
                      {voiddata?.length}{" "}
                    </span>
                    )
                  </span>
                </div>
              </Col>
            </Row>

            <Table className="align-items-center table-flush" responsive>
              <thead className="thead-light">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Client Name</th>
                  <th scope="col">Cycle</th>
                  <th scope="col">Amount</th>
                  <th scope="col">Date & Time sent</th>
                  <th scope="col">Total Amount</th>
                  <th scope="col">Gross Margin</th>
                  <th scope="col">Due Amount</th>
                  <th scope="col">Class</th>
                  <th scope="col">Status</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td
                      colSpan={12}
                      className="text-center align-middle w-full"
                    >
                      Please wait...
                      <Loader />
                    </td>
                  </tr>
                ) : filteredData?.length > 0 ? (
                  filteredData?.map((item, key) => {
                    return (
                      <tr key={key}>
                        <td style={{ padding: "0.3rem" }}>{key + 1}</td>
                        <td style={{ padding: "0.3rem" }}>
                          {item?.client?.first_name} {item?.client?.last_name}
                        </td>
                        <td style={{ padding: "0.3rem" }}>
                          {item?.cycleData?.[0]?.cycle_number}
                        </td>
                        <td style={{ padding: "0.3rem" }}>
                          {item?.total_amount}
                        </td>
                        <td style={{ padding: "0.3rem" }}>
                          {moment(item?.updatedAt).format("DD-MM-YYYY hh:mm A")}
                        </td>
                        <td style={{ padding: "0.3rem" }}>
                          {item?.total_amount}
                        </td>
                        <td>{item?.grossMargin}</td>
                        <td style={{ padding: "0.3rem" }}>
                          {item?.due_amount}
                        </td>
                        <td style={{ padding: "0.3rem" }}>
                          {item?.class?.name}
                        </td>{" "}
                        {/* Replace with actual class name if dynamic */}
                        <td style={{ padding: "0.3rem" }}>{item?.status}</td>
                        <td
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            padding: "0.3rem",
                            // justifyContent: "center",
                            // alignItems: "center",
                          }}
                        >
                          <UncontrolledTooltip
                            placement="bottom"
                            target="eyeTooltipps"
                          >
                            Edit
                          </UncontrolledTooltip>
                          <Link
                            style={{
                              margin: "0 5px",
                              fontSize: "15px",
                              color: "blue",

                              alignItems: "center",
                              display: "inline-block",
                              marginTop: "10px",

                              borderRadius: "30%",
                            }}
                            id="eyeTooltipps"
                            onClick={() => {
                              toggle1();
                              setClientId(item?.id);

                              setitem(item);
                            }}
                          >
                            <i className="fa-solid fa-pen-to-square"></i>
                          </Link>

                          <UncontrolledTooltip
                            placement="bottom"
                            target="userTooltip"
                          >
                            Delete
                          </UncontrolledTooltip>
                          <p
                            style={{
                              cursor: "pointer",
                              margin: "0 8px",
                              fontSize: "15px",
                              color: "red",
                              marginTop: "10px",

                              display: "inline-block",

                              borderRadius: "20%", // Optional: Make it a circle
                            }}
                            id="userTooltip"
                            onClick={() => {
                              deleteinvoice(item?.id);
                            }}
                          >
                            <i className="fas fa-trash"></i>
                          </p>

                          <UncontrolledTooltip
                            placement="bottom"
                            target="eyeTooltip"
                          >
                            View
                          </UncontrolledTooltip>
                          <Link
                            style={{
                              margin: "0 5px",
                              fontSize: "15px",
                              color: "blue",
                              // backgroundColor: "#f5f5f5",
                              alignItems: "center",
                              display: "inline-block",
                              marginTop: "10px",
                              // padding: "5px", // Optional: Add padding for better appearance
                              borderRadius: "30%", // Optional: Make it a circle
                            }}
                            id="eyeTooltip"
                            to={`/admin/viewinvoice/${item?.client_id}`}
                            // tag={Link}
                          >
                            <i class="fa-solid fa-eye"></i>
                          </Link>
                          {item?.status !== "Completed" && (
                            <>
                              <UncontrolledTooltip
                                placement="bottom"
                                target="marktopaid"
                              >
                                Mark to paid
                              </UncontrolledTooltip>
                              <Link
                                style={{
                                  margin: "0 5px",
                                  fontSize: "15px",
                                  color: "green",
                                  // backgroundColor: "#f5f5f5",
                                  alignItems: "center",
                                  display: "inline-block",
                                  marginTop: "10px",
                                  // padding: "5px", // Optional: Add padding for better appearance
                                  borderRadius: "30%", // Optional: Make it a circle
                                }}
                                id="marktopaid"
                                onClick={() => {
                                  toggle2();
                                  setClientId(item?.id);
                                }}
                                // to={`/admin/viewinvoice`}
                                // tag={Link}
                              >
                                <i className="fas fa-check"></i>
                              </Link>
                            </>
                          )}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      colSpan="12"
                      style={{ textAlign: "center", padding: "1rem" }}
                    >
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            <CardFooter className="py-4">
              {/* <TablePagination
                totalPages={parseInt(dataList?.meta?.total_page)}
                currentPage={parseInt(dataList?.meta?.current_page)}
                pageUrl="/admin/messages?"
              /> */}
            </CardFooter>
          </Card>
        </div>
      </Row>

      <Modal isOpen={modal} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>
          <h4>Raise Invoice</h4>
        </ModalHeader>
        <ModalBody>
          <form onSubmit={Invoicesubmmit}>
            <Row>
              <Col md={3}>
                <FormGroup>
                  <Label>Invoice id</Label>
                  <Input
                    type="text"
                    // onChange={handleName}
                    // value={name}
                    placeholder="Enter Invoice id "
                    name="invoice_number"
                  ></Input>
                </FormGroup>
              </Col>
              <Col md={5}>
                <FormGroup>
                  <Label> Client</Label>

                  <Select
                    options={options}
                    onChange={handleChange}
                    isClearable={true}
                    className=" rounded-6"
                  />
                </FormGroup>
              </Col>

              <Col md={4}>
                <FormGroup>
                  <Label>Class</Label>
                  <Input
                    name="class_id"
                    type="select"
                    onChange={(e) => {
                      getcycle(e.target.value);
                    }}
                  >
                    <option value="">Select Class </option>
                    {classlist?.data?.map((item, key) => {
                      return (
                        <option key={key} value={item?.id}>
                          {item?.name}{" "}
                        </option>
                      );
                    })}
                  </Input>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <FormGroup>
                  <Label>Cycle</Label>
                  {!cycle?.data?.data && <Input type="text"></Input>}
                  {cycle?.data?.data && (
                    <Input
                      name=""
                      type="select"
                      onChange={(e) => {
                        setClassidform(e.target.value);
                      }}
                    >
                      <option value="">Select Cycle </option>
                      {cycle?.data?.data?.map((item, key) => {
                        return (
                          <option value={item?.id} key={key}>
                            {item?.cycle_number}
                          </option>
                        );
                      })}
                    </Input>
                  )}
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <Label> Total Amount</Label>
                  <Input
                    type="text"
                    name="total_amount"
                    placeholder="Enter  Amount"
                  ></Input>
                </FormGroup>
              </Col>

              <Col md={4}>
                <FormGroup>
                  <Label> Due Amount</Label>
                  <Input
                    type="text"
                    // onChange={handleName}
                    defaultValue="0"
                    name="due_amount"
                    placeholder="Enter  Amount"
                  ></Input>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label> Invoice Amount</Label>
                  <Input
                    type="text"
                    name="invoice_amount"
                    placeholder="Enter  Amount"
                  ></Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Upload invoice</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    name="invoicePic"
                    type="file"
                    // onChange={handleName}
                    // value={name}
                    placeholder="Enter UPI id "
                  ></Input>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label for="exampleEmail">Note</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    name="notes"
                    type="textarea"
                    // onChange={handleName}
                    // value={name}
                    placeholder="Enter Note"
                  ></Input>
                </FormGroup>
              </Col>
            </Row>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggle}>
                Cancel
              </Button>
              {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
              <Button
                type="submit"
                style={{
                  float: "right",
                  marginLeft: "5%",
                  backgroundColor: "#080278",
                  color: "white",
                  border: "none",
                }}
                onClick={toggle}
              >
                Save
              </Button>
            </div>
          </form>
        </ModalBody>
      </Modal>
      <Modal isOpen={modal1} toggle={toggle1} size="lg">
        <ModalHeader toggle={toggle1}>
          <h4>Edit Invoice</h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={EditInvoice}>
            <Row>
              <Col md={2}>
                <FormGroup>
                  <Label>Invoice id</Label>
                  <Input
                    defaultValue={item?.invoice_number}
                    type="text"
                    placeholder="Enter Invoice id "
                    name="invoice_number"
                  ></Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>
                    Client ( {item?.client?.first_name}{" "}
                    {item?.client?.last_name} ( {item?.client?.username} ))
                  </Label>
                  <Select
                    options={options}
                    onChange={handleChange}
                    isClearable={true}
                    className=" rounded-6"
                  />
                </FormGroup>
              </Col>

              <Col md={4}>
                <FormGroup>
                  <Label>Class ( {item?.class?.name} )</Label>
                  <Input
                    type="select"
                    onChange={(e) => {
                      setidClass(e.target.value);
                      getcycle(e.target.value);
                    }}
                  >
                    <option value="">Select Class </option>
                    {classlist?.data?.map((item, key) => {
                      return (
                        <option key={key} value={item?.id}>
                          {item?.name}{" "}
                        </option>
                      );
                    })}
                  </Input>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <FormGroup>
                  <Label>Cycle ({item?.cycleData?.[0]?.cycle_number})</Label>
                  {!cycle?.data?.data && <Input type="text"></Input>}
                  {cycle?.data?.data && (
                    <Input
                      name=""
                      type="select"
                      onChange={(e) => {
                        setClassidform(e.target.value);
                      }}
                    >
                      <option value="">Select Cycle </option>
                      {cycle?.data?.data?.map((item, key) => {
                        return (
                          <option value={item?.id} key={key}>
                            {item?.cycle_number}
                          </option>
                        );
                      })}
                    </Input>
                  )}
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <Label> Total Amount</Label>
                  <Input
                    type="text"
                    name="total_amount"
                    placeholder="Enter  Amount"
                    defaultValue={item?.total_amount}
                  ></Input>
                </FormGroup>
              </Col>

              <Col md={4}>
                <FormGroup>
                  <Label> Due Amount</Label>
                  <Input
                    defaultValue={item?.due_amount}
                    type="text"
                    // onChange={handleName}
                    // value={name}
                    name="due_amount"
                    placeholder="Enter  Amount"
                  ></Input>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label> Invoice Amount</Label>
                  <Input
                    type="text"
                    name="invoice_amount"
                    placeholder="Enter  Amount"
                    defaultValue={item?.invoice_amount}
                  ></Input>
                </FormGroup>
              </Col>
              <Col md={2}>
                <Label>invoice</Label>
                <img
                  src={item?.invoicePic.image}
                  width="70px"
                  height="42px"
                  style={{ border: "1px solid lightgray", cursor: "pointer" }}
                  onClick={() => {
                    togglea();
                  }}
                />
              </Col>
              <Col md={4}>
                <FormGroup>
                  <Label>Upgrade invoice</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    name="invoicePic"
                    type="file"
                    // onChange={handleName}
                    // value={name}
                    placeholder="Enter UPI id"
                  ></Input>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label for="exampleEmail">Note</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    defaultValue={item?.notes}
                    name="notes"
                    type="textarea"
                    // onChange={handleName}
                    // value={name}
                    placeholder="Enter Note"
                  ></Input>
                </FormGroup>
              </Col>
            </Row>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggle1}>
                Cancel
              </Button>
              {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
              <Button
                type="submit"
                style={{
                  float: "right",
                  marginLeft: "5%",
                  backgroundColor: "#080278",
                  color: "white",
                  border: "none",
                }}
                onClick={toggle1}
              >
                Save
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
      <Modal isOpen={modal2} toggle={toggle2} size="md">
        <ModalHeader toggle={toggle2}>
          <h4>Mark to Paid</h4>
        </ModalHeader>

        <ModalBody>
          <Form onSubmit={MartoPaid}>
            <Row>
              <Col md={12}>
                <Label>Amount Paid</Label>
                <Input
                  type="text"
                  placeholder="Enter Invoice id "
                  name="amount_paid"
                ></Input>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Label>Date</Label>
                <Input type="date" name="date" />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Label>Pay mode</Label>
                <Input type="select" name="pay_mode">
                  <option value="Cash">CASH</option>
                  <option value="Neft/Imps">NEFT/IMPS</option>
                  <option value="Upi">UPI</option>
                  <option value="Others">Others</option>
                </Input>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Label>Reciept</Label>
                <Input
                  type="file"
                  name="reciept"
                  style={{
                    border: "1px solid lightgrey",
                    padding: "6px 10px",
                    borderRadius: "6px",
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Label>Transaction id</Label>
                <Input type="text" name="transaction_id" />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Label>Remark</Label>
                <Input name="remark" type="textarea" />
              </Col>
            </Row>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggle2}>
                Cancel
              </Button>
              {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
              <Button
                type="submit"
                style={{
                  float: "right",
                  marginLeft: "5%",
                  backgroundColor: "#080278",
                  color: "white",
                  border: "none",
                }}
                onClick={toggle2}
              >
                Save
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
      <Modal isOpen={modala} toggle={togglea} size="lg">
        <ModalHeader toggle={togglea}>
          <h4>Invoice Image</h4>
        </ModalHeader>

        <ModalBody>
          <img
            src={item?.invoicePic.image}
            style={{ width: "100%", objectFit: "cover" }}
            alt="invoice"
          ></img>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px",
            }}
          >
            {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
            <Button
              style={{
                float: "right",
                marginLeft: "5%",
                backgroundColor: "#080278",
                color: "white",
                border: "none",
              }}
              onClick={togglea}
            >
              Close
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default FinanceManagement;
